import * as React from 'react';
import MuiAlert, { AlertProps } from '@material-ui/core/Alert';

const Alert = React.forwardRef((props: AlertProps, ref) => {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default React.memo(Alert);
